import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/charts/line-demo/line-demo.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
